import { createPartyResolver } from '../../party-activity/partyActivity.model';
import { isCancelledRecord, isSettled, normalizedStatus } from '../../dashboard/utils/dashboard.obligations';
import { parseEuroToCents } from '../../../shared/utils/installments';

const unique = (rows) => [...new Map(rows.map((row) => [row.id == null ? row : String(row.id), row])).values()];
const completed = (row) => Boolean(row.completedAt) || ['completato', 'completata', 'completed', 'done', 'concluso', 'conclusa'].includes(normalizedStatus(row.status));

export function buildSupplierOverview(supplier, data = {}, suppliers = [supplier]) {
  const resolve = createPartyResolver('supplier', suppliers, data);
  const linked = (rows, type) => unique(rows || []).filter((row) => !isCancelledRecord(row) && resolve(row, type).has(String(supplier.id)));
  // Documents and activities can inherit a supplier through a deal, invoice or expense.
  const referencesReady = ['assignments', 'dealProposals', 'dealsInProgress', 'dealsCompleted', 'expenses', 'payments', 'invoices']
    .every((source) => Array.isArray(data[source]));
  let expenses = null, documents = null, activities = null;

  if (Array.isArray(data.expenses)) {
    const rows = linked(data.expenses, 'expense');
    const pending = rows.filter((row) => !isSettled(row.status));
    const amounts = pending.map((row) => parseEuroToCents(row.amount));
    expenses = {
      total: rows.length,
      paid: rows.length - pending.length,
      pending: pending.length,
      outstanding: amounts.some((amount) => amount === null) ? null : amounts.reduce((sum, amount) => sum + amount, 0) / 100,
    };
  }
  if (referencesReady && Array.isArray(data.documents)) {
    const rows = linked(data.documents, 'document');
    documents = {
      total: rows.length,
      invoices: rows.filter((row) => ['fattura', 'fatture', 'invoice'].includes(normalizedStatus(row.category))).length,
      contracts: rows.filter((row) => ['contratto', 'contratti', 'contract'].includes(normalizedStatus(row.category))).length,
    };
  }
  if (referencesReady && Array.isArray(data.documents) && Array.isArray(data.calendarEvents)) {
    const tasks = linked(data.assignments, 'assignment');
    const events = linked(data.calendarEvents, 'calendarEvent').filter((row) => !row.isReadOnly && row.source !== 'derived');
    const rows = [...tasks, ...events];
    const done = rows.filter(completed).length;
    activities = { total: rows.length, open: rows.length - done, completed: done };
  }
  return { expenses, documents, activities };
}
